/**
 * RDS Color 토큰.
 * @see https://www.figma.com/design/wcgji99mZRPIytCZDjwqxe/RDS-v1.0?node-id=2411-2
 */
export const rdsPrimary = {
  50: '#f2f4fd',
  100: '#e0e6f9',
  200: '#c8d3f5',
  300: '#a2b6ee',
  400: '#7691e4',
  500: '#4c65d9',
  600: '#4152cf',
  700: '#3940bd',
  800: '#34369a',
  900: '#2e327a',
} as const;

export const rdsGrey = {
  50: '#f5f7f9',
  100: '#f3f4f6',
  200: '#e5e7ea',
  300: '#d2d5db',
  400: '#9ea2ae',
  500: '#6d717f',
  600: '#4d5461',
  700: '#394050',
  800: '#212936',
  900: '#131927',
} as const;

export const rdsGreen = {
  50: '#ecf8ef',
  100: '#c5e9cd',
  200: '#a9deb4',
  300: '#81cf92',
  400: '#69c57d',
  500: '#43b75d',
  600: '#3da755',
  700: '#308242',
  800: '#256533',
  900: '#1c4d27',
} as const;

export const rdsBlue = {
  50: '#e3f3ff',
  100: '#bbdfff',
  200: '#8eccff',
  300: '#5db8ff',
  400: '#34a8ff',
  500: '#0099ff',
  600: '#0d8aff',
  700: '#1577eb',
  800: '#1965d8',
  900: '#1b45b9',
} as const;

export const rdsYellow = {
  50: '#fff7e6',
  100: '#ffe5b0',
  200: '#ffd88a',
  300: '#ffc654',
  400: '#ffbb33',
  500: '#ffaa00',
  600: '#e89b00',
  700: '#b57900',
  800: '#8c5e00',
  900: '#6b4700',
} as const;

export const rdsRed = {
  50: '#fdecec',
  100: '#fac5c3',
  200: '#f7a9a7',
  300: '#f4827e',
  400: '#f16965',
  500: '#ee443f',
  600: '#d93e39',
  700: '#a9302d',
  800: '#832523',
  900: '#641d1a',
} as const;

/** Black / White 투명도 (8자리 hex) */
export const rdsTransparency = {
  black: {
    10: '#0000001a',
    20: '#00000033',
    30: '#0000004d',
    40: '#00000066',
    50: '#00000080',
    60: '#00000099',
    70: '#000000b2',
    80: '#000000cc',
    90: '#000000e5',
    100: '#000000',
  },
  white: {
    10: '#ffffff1a',
    20: '#ffffff33',
    30: '#ffffff4d',
    40: '#ffffff66',
    50: '#ffffff80',
    60: '#ffffff99',
    70: '#ffffffb2',
    80: '#ffffffcc',
    90: '#ffffffe5',
    100: '#ffffff',
  },
} as const;

export const rdsGraphic = {
  yellow: '#f9d02e',
  orange: '#fc7d3c',
  pink: '#ff8caa',
  blue: '#1395ff',
  mint: '#43ceb8',
  green: '#0fb961',
} as const;

export const rdsSectionBg = {
  planning: '#444444',
  design: '#24435a',
} as const;

export const rdsText = {
  primaryBlack: '#131927',
  primaryWhite: '#ffffff',
  accent: '#4152cf',
} as const;

export const rdsSurface = {
  white: '#ffffff',
  grey: '#f5f7f9',
} as const;

export const rdsColors = {
  primary: rdsPrimary,
  grey: rdsGrey,
  status: {
    success: rdsGreen,
    info: rdsBlue,
    warning: rdsYellow,
    error: rdsRed,
  },
  transparency: rdsTransparency,
  graphic: rdsGraphic,
  sectionBg: rdsSectionBg,
  text: rdsText,
  surface: rdsSurface,
} as const;
